module.exports = __webpack_public_path__ + "static/airmason_jeet-6f69f89bbde3fe67eb19d820d2513209.png";